import { render } from "./pivot.vue?vue&type=template&id=097ff0ea"
import script from "./pivot.vue?vue&type=script&lang=js"
export * from "./pivot.vue?vue&type=script&lang=js"

import "./pivot.vue?vue&type=style&index=0&id=097ff0ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__